module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"vacancy":"Вакансия","salary":"Зарплата","city":"Город"}}')
  delete Component.options._Ctor
}
